import React from "react";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";
import { Link } from "react-router-dom";

const FactureCard = ({ title, data, backUrl }) => {
  return (
    <>
      <CardTitle className="h5" style={{ color: "#555b21" }}>
        {title}
      </CardTitle>
      <Card className="shadow-sm">
        <CardBody>
          {Object.entries(data).map(([category, items]) => (
            <div key={category}>
              <h6 className="mt-3 mb-2">{category}</h6>
              {items.map((item, index) => (
                <div key={index} className="d-flex flex-column mb-2">
                  <div className="d-flex align-items-center">
                    {item.id && (
                      <Link
                        className="btn btn-sm btn-soft-primary mr-2"
                        id="viewtooltip-2"
                        to={`${backUrl}/fx_paiements/${item.id}/apercu_facture`}
                      >
                        <i className="mdi mdi-eye-outline"></i>
                      </Link>
                    )}
                    <div style={{ color: "#555b21", paddingLeft: 10 }}>
                      <span>{item.text_top}</span>
                      {item.text_bottom && (
                        <div className="text-muted">{item.text_bottom}</div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </CardBody>
      </Card>
    </>
  );
};

export default FactureCard;
